import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import './styles.scss';
import cn from 'classnames';

const MyBreadcrumb = ({ className, breadcrumbs = [], breadcrumbExtension }) => {
  if (!breadcrumbs?.length && !breadcrumbExtension?.length) return null;
  if (breadcrumbExtension?.length) {
    breadcrumbs = [...breadcrumbs, ...breadcrumbExtension];
  }
  return (
    <Breadcrumb className={cn('my-breadcrumb', className)} separator="/">
      {breadcrumbs.map((item, idx) => {
        const isLastChild = idx + 1 === breadcrumbs.length;
        return (
          <Breadcrumb.Item key={idx}>
            {item.link ? (
              <Link
                to={item.link}
                className={cn('my-breadcrumb-item', {
                  active: isLastChild || item.active,
                })}
              >
                {item.name}
              </Link>
            ) : (
              <span
                className={cn('my-breadcrumb-item', {
                  active: isLastChild || item.active,
                })}
              >
                {item.name}
              </span>
            )}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};

export default MyBreadcrumb;
